import { TextBodyMedium } from '@/components/text/Texts';

const ScreenFooterText = ({ className = '' }) => {
	return (
		<TextBodyMedium
			className={className}
			text={`Xpress for Business Version ${import.meta.env.VITE_BUILD_VERSION_NUMBER}`}
		/>
	);
};

export default ScreenFooterText;
